

































import VueOptions from '@utils/VueOptions'

settings =
  name: 'SpaceDisplay'

  resources:
    availabilities:
      resourceName: 'audience_availability'
      slug: 'suppliers/:supplierId/spaces/:spaceId/audience_availabilities'
      params:
        quick_list: true
    supplier:
      resourceName: 'supplier'
      slug: 'suppliers/:supplierId'

  vue:
    props: ['space', 'options']

    computed:
      supplierId: -> @options?.supplierId || @$store.member.supplier.id
      spaceId: -> @space.id

      supplierAvailabilityIds: -> @supplier?.availability_ids || []
      supplierAvailabilities: ->
        items = []
        for availability in (@availabilities || [])
          items.push availability if availability.id in @supplierAvailabilityIds
        items

      spaceAvailabilitiesTableData: ->
        type = 'sampling_capacity' if @space.type is 'product_sampling'
        type ||= 'reach'
        for availability in (@supplierAvailabilities || [])
          capacity = availability.engagement_capacity[@space.segment]?[type] || {}
          capacity = if @isEmptyValue(capacity.daily) then capacity.default else capacity.daily 
          capacity ||= {}
          id: availability.id
          data: availability
          experience: availability.title
          location: @$options.filters.formatLocation(availability)
          venue: availability.venue_name
          capacity_count: Object.values(capacity).reduce(((acc, value) => acc + parseInt(value)), 0)

export default VueOptions.vue settings
